import React, { FC } from 'react';
import { InboxView } from '../components';

export const InboxPage: FC = () => {
  return <InboxView />;
};
